module.exports = __webpack_public_path__ + "img/PER.cbe504c6.svg";